import { Typography } from '@mui/material';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import TranscricaoAnexosUpload from '../../components/TranscricaoAnexos';
import CidadesAtendidasDropdown from '../CidadesAtendidasDropdown';
import { useTranscricao } from '../context';

const StepAnexos: React.FC = () => {
  const accessibility = useAccessibility();
  const { state, dispatch } = useTranscricao();

  return (
    <div className="transcricao-step-content transcricao-step-content--anexos">
      <Typography
        style={accessibility.textStyleAccessibility}
        className="transcricao-anexos-section-title"
      >
        <strong>Anexe o(s) pedido(s) médico(s)</strong>
      </Typography>

      <CidadesAtendidasDropdown />

      <TranscricaoAnexosUpload
        anexos={state.anexos}
        onAnexosChange={(anexos) => dispatch({ type: 'SET_ANEXOS', payload: anexos })}
        onValidandoChange={(validando) =>
          dispatch({ type: 'SET_VALIDANDO_ANEXO', payload: validando })
        }
      />
    </div>
  );
};

export default StepAnexos;
